(function(){
'use strict';

const CDN='https://cdn.shopify.com/s/files/1/0657/3424/6634/files/';

const BEADS=[
  {id:'lava',name:'Lavastein',img:CDN+'perlelavastein.png?v=1766748823',tags:['schwarz','struktur'],meaning:'Lavastein: Erdung · Stabilität · innere Stärke.'},
  {id:'sunstone_glow',name:'Sunstone Glow',img:CDN+'perleSunstone_Glow.png?v=1766749519',tags:['apricot','glow'],meaning:'Sunstone Glow: Wärme · Vitalität · Leuchtkraft von innen.'},
  {id:'obsidian_glossy',name:'Obsidian glänzend',img:CDN+'perleobsidian.png?v=1766747422',tags:['schwarz','glanz'],meaning:'Obsidian: Schutz · Klarheit · Fokus.'},
  {id:'onyx_matt',name:'Onyx matt',img:CDN+'perleonyxmatt.png?v=1766747773',tags:['schwarz','matt'],meaning:'Onyx: Klarheit · innere Stärke · Ruhe.'},
  {id:'malaysia_white',name:'Malaysia Jade weiß',img:CDN+'perleMalaysia_weiss.png?v=1766748109',tags:['weiß'],meaning:'Malaysia Jade: Balance · Ruhe · Zuversicht.'},
  {id:'lapislazuli',name:'Lapislazuli',img:CDN+'perleLapislazuli.png?v=1766748109',tags:['blau'],meaning:'Lapislazuli: Weisheit · Klarheit · innere Wahrheit.'},
  {id:'tigerauge',name:'Tigerauge',img:CDN+'perletigeruage.png?v=1766748108',tags:['gold','braun'],meaning:'Tigerauge: Mut · Selbstvertrauen · Richtung.'},
  {id:'malaysia_olive',name:'Malaysia Jade (Olivgrün)',img:CDN+'Perle_Malaysia_olivgruen.png?v=1766762145',tags:['oliv','grün'],meaning:'Balance · Fokus · Klarheit.'},
  {id:'malaysia_red',name:'Malaysia Jade (Rot)',img:CDN+'Perle_Malaysia_rot.png?v=1766762144',tags:['rot'],meaning:'Energie · Zuversicht · Ausdruck.'}
];

const C10=new Set(['onyx_matt','obsidian_glossy','lava','tigerauge']);

const FIT_EXAMPLES=[
  {key:'exact',title:'Exakt / eng',text:'Nah am Handgelenk. Wenig Spielraum.',img:CDN+'lorencik-groessenguide-exakt-eng.png?width=180'},
  {key:'normal',title:'Normal angenehm',text:'Unsere Empfehlung für Alltag und Komfort.',img:CDN+'lorencik-groessenguide-normal-angenehm.png?width=180'},
  {key:'loose',title:'Locker sitzend',text:'Mehr Bewegung, entspannter Sitz.',img:CDN+'lorencik-groessenguide-locker-sitzend.png?width=180'}
];

const SIZE_PROFILES={
  s:{label:'S',wristCm:17,help:'ca. 17 cm Handgelenkumfang'},
  m:{label:'M',wristCm:18,help:'ca. 18 cm Handgelenkumfang'},
  l:{label:'L',wristCm:19,help:'ca. 19 cm Handgelenkumfang'},
  xl:{label:'XL',wristCm:20,help:'ca. 20 cm Handgelenkumfang'},
  custom:{label:'Wunschgröße',wristCm:null,help:'individueller Handgelenkumfang'}
};

const FIT_PROFILES={
  exact:{label:'Exakt / eng',short:'eng',addCm:.5,help:'sitzt nah am Handgelenk'},
  normal:{label:'Normal angenehm',short:'normal',addCm:1,help:'klassische Lorencik-Empfehlung'},
  loose:{label:'Locker sitzend',short:'locker',addCm:1.5,help:'mehr Bewegungsspielraum'}
};

const BEAD_MM=8;
const MIN_BEADS=21;
const MAX_BEADS=28;
const PCFG={cx:800,cy:520,rx:435,ry:150,rot:0,tight:1.68,minR:40,maxR:78};
const CCFG={cx:800,cy:480,rx:510,ry:185,rot:0,tight:1.95,minR:56,maxR:94};

const WS=[
  {l:'Schritt 1 von 7',t:'Wie groß soll dein Armband sein?',e:'Miss deinen Handgelenkumfang und wähle die passende Größe. Bei Wunschgröße gibst du deinen gemessenen Umfang direkt ein.',lk:{u:'https://www.lorencik.com/pages/wunschgrosse',tx:'Hilfe beim Messen →'},p:'tlen'},
  {l:'Schritt 2 von 7',t:'Wie soll dein Armband sitzen?',e:'Wähle aus, ob dein Armband eher eng, normal oder locker getragen werden soll.',p:'tfit',visual:'fit'},
  {l:'Schritt 3 von 7',t:'Wähle deine Wunschperle aus dem Katalog.',e:'Diese Perle kannst du gleich als Basis für dein gesamtes Armband verwenden.',p:'cat'},
  {l:'Schritt 4 von 7',t:'Fülle das Armband mit deiner Wunschperle.',e:'Alle freien Positionen werden automatisch mit deiner aktiven Perle gefüllt. Danach kannst du einzelne Stellen weiter anpassen.',p:'prev',visual:'fill'},
  {l:'Schritt 5 von 7',t:'Passt dein Wunscharmband so?',e:'Ändere bei Bedarf einzelne Punkte direkt im Armband. Wenn alles passt, tippe auf „Passt so“, dann geht es zur Mittelperle.',p:'prev'},
  {l:'Schritt 6 von 7',t:'Mittelperle: 8 mm oder 10 mm?',e:'8 mm ist klassisch. 10 mm ist nur bei Onyx, Obsidian, Lavastein und Tigerauge verfügbar.',p:'tcsz'},
  {l:'Schritt 7 von 7',t:'Prüfe dein Wunscharmband. Wenn alles passt, lege es in den Warenkorb.',p:'prev'}
];

const S={sym:true,size:'m',fit:'normal',total:24,active:'lava',center:'onyx_matt',csz:8,seq:Array(24).fill(null)};
const hist=[];
const lastR={stage:null,ao:0,cpt:null};
let wiz=false,wstep=1;

const $=id=>document.getElementById(id);
const elCat=$('lg-catalog'),elQ=$('lg-q'),elSym=$('lg-sym');
const elC=$('lg-c'),ctx=elC.getContext('2d');
const elR=$('lg-rc'),rctx=elR.getContext('2d');
const elPre=$('lg-sizePreset'),elCust=$('lg-sizeCustom'),elCSZ=$('lg-centerSz'),elFit=$('lg-fitPreset');
const elSH=$('lg-sizeHint'),elCW=$('lg-customWrap');
const elPT=$('lg-posTxt'),elCT=$('lg-ctrTxt'),elNT=$('lg-noteTxt');
const elSZ=$('lg-sizeTxt'),elWR=$('lg-wristTxt'),elFT=$('lg-fitTxt'),elTG=$('lg-targetTxt'),elIN=$('lg-internalTxt'),elPR=$('lg-productTypeTxt');
const elKL=$('lg-klen'),elKF=$('lg-kfit'),elKC=$('lg-kcsz'),elKB=$('lg-kbeads'),elKS=$('lg-ksym');
const elFB=$('lg-fbar'),elFH=$('lg-fhint');
const elWB=$('lg-wiz'),elWL=$('lg-wlbl'),elWT=$('lg-wtxt');
const elWE=$('lg-we'),elWLk=$('lg-wlink');
const elWBk=$('lg-wback'),elWN=$('lg-wnext');
const elCS=$('lg-co-stats'),elCC=$('lg-co-cap');
const elStrip=$('lg-config-strip');

const getBead=id=>BEADS.find(b=>b.id===id)??null;
const ci=()=>Math.floor(S.total/2);
const cname=()=>getBead(S.center)?.name??'—';
const cimg=()=>getBead(S.center)?.img??'';
const esc=s=>String(s??'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
const clamp=(n,min,max)=>Math.max(min,Math.min(max,n));
const fmtCm=n=>{if(n===null||n===undefined||Number.isNaN(n))return '—';return String(Math.round(Number(n)*10)/10).replace('.',',')};

function wristFromState(){
  if(S.size==='custom'){
    const raw=String(elCust?.value||'').replace(',','.');
    const n=parseFloat(raw);
    return Number.isFinite(n)&&n>0?n:null;
  }
  return SIZE_PROFILES[S.size]?.wristCm??18;
}

function targetFromState(){
  const wrist=wristFromState();
  if(!wrist)return null;
  const add=FIT_PROFILES[S.fit]?.addCm??1;
  return Math.round((wrist+add)*10)/10;
}

function beadCountFromState(){
  const target=targetFromState();
  if(!target)return S.total||24;
  return clamp(Math.round((target*10)/BEAD_MM),MIN_BEADS,MAX_BEADS);
}

function sizeLabel(){
  const sp=SIZE_PROFILES[S.size]||SIZE_PROFILES.m;
  if(S.size==='custom')return `Wunschgröße ${fmtCm(wristFromState())} cm`;
  return `${sp.label} · ${fmtCm(sp.wristCm)} cm`;
}

function sizeRangeLabel(){
  if(S.size==='custom')return `Wunschgröße ${fmtCm(wristFromState())} cm`;
  const ranges={s:'S – 17 cm',m:'M – 18–19 cm',l:'L – 19–20 cm',xl:'XL – 20–21 cm'};
  return ranges[S.size]||'M - 18-19 cm';
}

function fitLabel(){return FIT_PROFILES[S.fit]?.label??'Normal angenehm'}

function internalLine(){
  const target=targetFromState();
  return `Fertigungslänge ca. ${fmtCm(target)} cm, ${S.total} Perlen inkl. Mittelperle`;
}

function applySizeSystem(){
  const n=beadCountFromState();
  if(n!==S.total)rsz(n);
}

const rp=(x,y,a)=>{const c=Math.cos(a),s=Math.sin(a);return{x:x*c-y*s,y:x*s+y*c}};
const ep=(rx,ry)=>{const h=(rx-ry)**2/(rx+ry)**2;return Math.PI*(rx+ry)*(1+3*h/(10+Math.sqrt(4-3*h)))};

const sf=cfg=>{
  const s={...cfg};
  if(S.total===24){s.rx+=12;s.ry+=4}
  if(S.total===25){s.rx+=24;s.ry+=8}
  if(S.total===26){s.rx+=36;s.ry+=10}
  if(S.total>=27){s.rx+=48;s.ry+=12}
  return s;
};

function ss(i,id){const c=ci(),m=S.total-1-i;S.seq[i]=id;if(S.sym&&m!==c&&m!==i)S.seq[m]=id}
function cs(i){const c=ci(),m=S.total-1-i;S.seq[i]=null;if(S.sym&&m!==c&&m!==i)S.seq[m]=null}
function ts(i){S.seq[i]?cs(i):ss(i,S.active)}

function fillWithActiveBead(){
  ph();
  const centerIndex=ci();
  for(let i=0;i<S.total;i++){if(i===centerIndex)continue;S.seq[i]=S.active}

  const pv=document.querySelector('.lg-panel-prev');
  if(pv){pv.classList.remove('lg-orbit-fill');void pv.offsetWidth;pv.classList.add('lg-orbit-fill')}

  const cp=lastR.cpt;
  if(cp){
    for(let a=0;a<10;a++){
      setTimeout(()=>{
        const angle=(Math.PI*2/10)*a;
        ar(cp.x+Math.cos(angle)*90,cp.y+Math.sin(angle)*42,true);
      },a*38);
    }
  }

  if(wiz&&wstep===4){wstep=5;uwiz()}
  sr();
}

function ph(){hist.push({...S,seq:S.seq.slice()});if(hist.length>80)hist.shift()}

function uh(){
  const h=hist.pop();
  if(!h)return;
  Object.assign(S,h);
  S.seq=h.seq.slice();
  elSym.checked=S.sym;
  elSym.setAttribute('aria-checked',String(S.sym));
  elPre.value=S.size||'m';
  if(elFit)elFit.value=S.fit||'normal';
  syncCW((S.size||'m')==='custom');
}

function rsz(n){
  const oc=ci(),nc=Math.floor(n/2),old=S.seq.slice(),next=Array(n).fill(null);
  for(let i=0;i<S.total;i++){
    if(i===oc||!old[i])continue;
    const ni=nc+(i-oc);
    if(ni>=0&&ni<n&&ni!==nc)next[ni]=old[i];
  }
  S.total=n;
  S.seq=next;
}

const ic=new Map();

function li(url){
  return new Promise(r=>{
    if(!url)return r(null);
    if(ic.has(url))return r(ic.get(url));
    const im=new Image();
    im.crossOrigin='anonymous';
    im.onload=()=>{ic.set(url,im);r(im)};
    im.onerror=()=>{ic.set(url,null);r(null)};
    im.src=url;
  });
}

function ec(){if(S.csz===10&&!C10.has(S.center))S.csz=8}

function scd(){
  const ok=C10.has(S.center),o=elCSZ.querySelector('option[value="10"]');
  if(o){o.disabled=!ok;o.textContent=ok?'10 mm':'10 mm (nicht verfügbar)'}
  if(!ok&&S.csz===10)S.csz=8;
  elCSZ.value=String(S.csz);
}

function syncCW(on){
  elCW.style.display=on?'block':'none';
  elCW.setAttribute('aria-hidden',String(!on));
  elSH.style.display=on?'block':'none';
}

const rips=[];
let rRAF=null;

function ar(x,y,gold=false){
  rips.push({x,y,r:0,a:gold?.85:.65,g:gold});
  if(!rRAF)tr();
}

function tr(){
  rctx.clearRect(0,0,elR.width,elR.height);

  for(let i=rips.length-1;i>=0;i--){
    const p=rips[i];
    p.r+=6;
    p.a-=.034;
    if(p.a<=0){rips.splice(i,1);continue}
    const cl=p.g?'212,175,55':'255,255,255';
    rctx.save();
    rctx.beginPath();
    rctx.arc(p.x,p.y,p.r,0,Math.PI*2);
    rctx.strokeStyle=`rgba(${cl},${p.a})`;
    rctx.lineWidth=2;
    rctx.stroke();

    if(p.r<24){
      rctx.beginPath();
      rctx.arc(p.x,p.y,7,0,Math.PI*2);
      rctx.fillStyle=`rgba(${cl},${p.a*.7})`;
      rctx.fill();
    }

    rctx.restore();
  }

  rRAF=rips.length?requestAnimationFrame(tr):null;
}

async function db(c,cfg,ref){
  const stage=sf(cfg),cIdx=ci(),ao=(Math.PI/2)-(cIdx/S.total)*Math.PI*2;
  const baseR=Math.max(cfg.minR,Math.min(cfg.maxR,(ep(stage.rx,stage.ry)/S.total/2)*cfg.tight));
  const csc=S.csz===10?1.16:1.0;
  const needed=new Set(S.seq.filter(Boolean));
  needed.add('__c__');

  const imgs={};

  await Promise.all([...needed].map(async id=>{
    imgs[id]=await li(id==='__c__'?cimg():(getBead(id)?.img??''));
  }));

  const pts=[];

  for(let i=0;i<S.total;i++){
    const isC=(i===cIdx),id=isC?'__c__':S.seq[i];
    if(!id&&!isC)continue;
    const a=(i/S.total)*Math.PI*2+ao;
    const rpv=rp(Math.cos(a)*stage.rx,Math.sin(a)*stage.ry,stage.rot);
    const x=stage.cx+rpv.x,y=stage.cy+rpv.y,r=isC?baseR*csc:baseR;
    if(isC&&ref)ref.cpt={x,y,r};
    pts.push({id:isC?'__c__':id,x,y,depth:y,r});
  }

  pts.sort((a,b)=>a.depth-b.depth);

  for(const pt of pts){
    const im=imgs[pt.id];
    if(!im)continue;
    c.save();
    c.beginPath();
    c.arc(pt.x,pt.y,pt.r,0,Math.PI*2);
    c.clip();
    c.drawImage(im,pt.x-pt.r,pt.y-pt.r,pt.r*2,pt.r*2);
    c.restore();
  }

  return{stage,ao,baseR};
}

function dhs(c,stage,ao,bR){
  const cIdx=ci(),dR=Math.max(7,Math.min(14,bR*.22)),rR=dR*.95;

  for(let i=0;i<S.total;i++){
    if(i===cIdx)continue;
    const a=(i/S.total)*Math.PI*2+ao;
    const rpv=rp(Math.cos(a)*stage.rx*1.06,Math.sin(a)*stage.ry*1.06,stage.rot);
    const x=stage.cx+rpv.x,y=stage.cy+rpv.y;

    c.beginPath();
    c.arc(x,y,rR,0,Math.PI*2);
    c.fillStyle=S.seq[i]?'rgba(11,15,16,.55)':'rgba(11,15,16,.22)';
    c.fill();

    c.beginPath();
    c.arc(x,y,dR*.55,0,Math.PI*2);
    c.fillStyle=S.seq[i]?'rgba(255,255,255,.88)':'rgba(255,255,255,.70)';
    c.fill();

    c.beginPath();
    c.arc(x,y,rR,0,Math.PI*2);
    c.strokeStyle='rgba(255,255,255,.22)';
    c.lineWidth=1;
    c.stroke();
  }
}

function dcm(c,x,y,r){
  const mr=Math.max(10,Math.min(16,r*.22));
  c.save();
  c.beginPath();
  c.arc(x,y,mr,0,Math.PI*2);
  c.fillStyle='rgba(11,15,16,.32)';
  c.fill();

  c.beginPath();
  c.arc(x,y,mr*.55,0,Math.PI*2);
  c.fillStyle='rgba(255,255,255,.9)';
  c.fill();

  c.fillStyle='rgba(11,15,16,.95)';
  c.font='900 12px system-ui,sans-serif';
  c.textAlign='center';
  c.textBaseline='middle';
  c.fillText('M',x,y+.5);
  c.restore();
}

let rPend=false;

function sr(){
  if(rPend)return;
  rPend=true;

  requestAnimationFrame(async()=>{
    rPend=false;
    ec();
    scd();
    rc();
    ukpi();
    syncFitCards();
    usummary();
    uprog();

    elC.classList.add('loading');
    ctx.clearRect(0,0,elC.width,elC.height);

    const bg=ctx.createLinearGradient(0,0,0,elC.height);
    bg.addColorStop(0,'#fff');
    bg.addColorStop(1,'#f0f1f2');

    ctx.fillStyle=bg;
    ctx.fillRect(0,0,elC.width,elC.height);

    const{stage,ao,baseR}=await db(ctx,PCFG,lastR);
    lastR.stage=stage;
    lastR.ao=ao;
    dhs(ctx,stage,ao,baseR);
    if(lastR.cpt)dcm(ctx,lastR.cpt.x,lastR.cpt.y,lastR.cpt.r);
    elC.classList.remove('loading');
    uh2();
  });
}

async function rco(){
  const co=$('lg-co-c');
  if(!co)return;

  const c=co.getContext('2d');
  c.fillStyle='#080808';
  c.fillRect(0,0,co.width,co.height);

  await db(c,CCFG,null);

  const cn=cname(),ls=sizeLabel(),fit=fitLabel(),target=targetFromState();
  const filled=S.seq.filter(Boolean).length;

  elCC.textContent=`${ls} · ${fit} · Zielumfang ca. ${fmtCm(target)} cm · Mitte: ${cn}`;

  elCS.innerHTML=
    `<span class="lg-co-stat"><strong>${esc(ls)}</strong></span>`+
    `<span class="lg-co-stat">Sitz: <strong>${esc(fit)}</strong></span>`+
    `<span class="lg-co-stat">Zielumfang: <strong>ca. ${esc(fmtCm(target))} cm</strong></span>`+
    `<span class="lg-co-stat">Mitte: <strong>${esc(cn)} ${S.csz} mm</strong></span>`+
    `<span class="lg-co-stat"><strong>${filled}</strong> Perlen</span>`+
    `<span class="lg-co-stat">${S.sym?'Symmetrisch':'Frei'}</span>`;
}

function rc(){
  const q=elQ.value.toLowerCase().trim();
  const items=q?BEADS.filter(b=>(b.name+' '+b.tags.join(' ')+' '+(b.meaning??'')).toLowerCase().includes(q)):BEADS;

  elCat.innerHTML=items.map((b,i)=>{
    const act=b.id===S.active;
    return `
      <div class="lg-item${act?' active':''}" role="listitem" tabindex="0" data-bead="${esc(b.id)}" aria-pressed="${act}" style="animation-delay:${i*38}ms">
        ${act?'<div class="lg-abadge">Aktiv</div>':''}
        <button type="button" class="lg-ibtn" data-info="${esc(b.id)}" aria-label="Info zu ${esc(b.name)}">i</button>
        <div class="lg-tip" role="tooltip"><strong>${esc(b.name)}</strong>${esc(b.meaning??'')}</div>
        <img class="lg-thumb" src="${b.img}" alt="${esc(b.name)}" loading="lazy">
        <div class="lg-name">${esc(b.name)}</div>
        <div class="lg-tags">${esc(b.tags.join(' · '))}</div>
      </div>
    `;
  }).join('');
}

function ptag(el){
  if(!el)return;
  el.classList.remove('pop');
  void el.offsetWidth;
  el.classList.add('pop');
}

function ukpi(){
  const ls=sizeLabel();
  const fs=FIT_PROFILES[S.fit]?.short??'normal';
  const cs='Mitte '+S.csz+' mm';
  const bs=S.total+' Perlen';
  const ss=S.sym?'symmetrisch':'frei';

  if(elKL&&elKL.textContent!==ls){elKL.textContent=ls;ptag(elKL)}
  if(elKF&&elKF.textContent!==fs){elKF.textContent=fs;ptag(elKF)}
  if(elKC&&elKC.textContent!==cs){elKC.textContent=cs;ptag(elKC)}
  if(elKB&&elKB.textContent!==bs){elKB.textContent=bs;ptag(elKB)}
  if(elKS&&elKS.textContent!==ss){elKS.textContent=ss;ptag(elKS)}
}

function syncFitCards(){
  document.querySelectorAll('#lg-wrap .lg-fit-card[data-fit]').forEach(card=>{
    const active=card.dataset.fit===S.fit;
    card.classList.toggle('active',active);
    card.setAttribute('aria-pressed',String(active));
  });
}

function usummary(){
  if(!elStrip)return;
  const fit=FIT_PROFILES[S.fit]?.short||'normal';
  const target=targetFromState();
  const sym=S.sym?'symmetrisch':'frei';
  elStrip.textContent=`Größe ${sizeRangeLabel()} Umfang · Sitz ${fit} → Zielumfang ca. ${fmtCm(target)} cm · ${S.total} Perlen inkl. Mittelperle · ${sym}.`;
}

function uprog(){
  const tot=S.total-1,fil=S.seq.filter(Boolean).length,pct=Math.round(fil/tot*100);
  elFB.style.width=pct+'%';
  elFH.textContent=fil===0?'Noch keine Perlen gesetzt':pct<50?`${fil} von ${tot} Positionen belegt`:pct<100?`Fast fertig — noch ${tot-fil} frei`:'Alle Positionen gesetzt ✓';
}

function uh2(){
  const cIdx=ci();

  const pm=Array.from({length:S.total},(_,i)=>{
    if(i===cIdx)return`${i+1}: [MITTE] ${cname()} (${S.csz}mm)`;
    const b=S.seq[i]?getBead(S.seq[i]):null;
    return b?`${i+1}: ${b.name}`:null;
  }).filter(Boolean).join('\n');

  const wrist=wristFromState();
  const target=targetFromState();

  const note=($('lg-note')?.value||'').trim()||null;

  if(elPT)elPT.value=pm;
  if(elCT)elCT.value=`${cname()} (${S.csz} mm)`;
  if(elSZ)elSZ.value=S.size==='custom'?`${fmtCm(wrist)} cm`:'-';
  if(elWR)elWR.value=sizeRangeLabel();
  if(elFT)elFT.value=fitLabel();
  if(elTG)elTG.value=`ca. ${fmtCm(target)} cm`;
  if(elIN)elIN.value=internalLine();
  if(elPR)elPR.value=`${S.csz} mm Perlenarmband`;
  if(elNT)elNT.value=note??'';
}

function cxy(ev){
  const r=elC.getBoundingClientRect(),sx=elC.width/r.width,sy=elC.height/r.height;
  const cx=ev.clientX??ev.touches?.[0]?.clientX??0,cy=ev.clientY??ev.touches?.[0]?.clientY??0;
  return{x:(cx-r.left)*sx,y:(cy-r.top)*sy};
}

function ich(x,y){
  const cp=lastR.cpt;
  return cp?Math.hypot(x-cp.x,y-cp.y)<=cp.r*.92:false;
}

function sxy(x,y){
  const{stage,ao}=lastR;
  if(!stage)return null;

  const dx=x-stage.cx,dy=y-stage.cy;
  const ca=Math.cos(-stage.rot),sa=Math.sin(-stage.rot);
  const ux=dx*ca-dy*sa,uy=dx*sa+dy*ca;
  const ring=Math.hypot(ux/stage.rx,uy/stage.ry);

  if(ring<.72||ring>1.34)return null;

  let raw=(Math.atan2(uy/stage.ry,ux/stage.rx)-ao)/(Math.PI*2);
  raw=raw-Math.floor(raw);

  return Math.round(raw*S.total)%S.total;
}

function showScr(n){
  document.querySelectorAll('.lg-screen').forEach(s=>{
    s.style.display='none';
    s.classList.remove('screen-in');
  });

  const t=document.getElementById(`lg-screen-${n}`);
  t.style.display='';
  void t.offsetWidth;
  t.classList.add('screen-in');

  if(n==='config')elWB.style.display=wiz?'block':'none';
  else elWB.style.display='none';

  if(n==='checkout'){uh2();rco()}
  window.scrollTo({top:0,behavior:'smooth'});
}

function setWiz(on){
  wiz=on;
  $('lg-mode-btn').textContent=on?'Geführt aktiv':'Geführt';

  if(on){
    wstep=1;
    uwiz();
    elWB.style.display='block';
  }else{
    elWB.style.display='none';
    clwhl();
  }
}

function uwiz(){
  const s=WS[wstep-1];
  elWL.textContent=s.l;
  elWT.textContent=s.t;

  if(elWE){
    elWE.textContent=s.e||'';
    elWE.style.display=s.e?'block':'none';
  }

  if(elWLk){
    if(s.lk){
      elWLk.textContent=s.lk.tx;
      elWLk.href=s.lk.u;
      elWLk.style.display='inline-block';
    }else{
      elWLk.style.display='none';
    }
  }

  renderWizardVisual(s);

  document.querySelectorAll('.lg-wdot').forEach((d,i)=>{
    d.classList.remove('done','active');
    if(i+1<wstep)d.classList.add('done');
    if(i+1===wstep)d.classList.add('active');
  });

  clwhl();

  const map={tlen:'#lg-tlen',tfit:'#lg-tfit',cat:'.lg-panel-cat',prev:'.lg-panel-prev',tcsz:'#lg-tcsz',tsym:'#lg-tsym'};
  const sel=map[s.p];

  if(sel){
    const el=document.querySelector(sel);
    if(el){
      focusWizardTarget(el,s);
    }
  }

  elWBk.disabled=wstep===1;
  elWN.textContent=wstep===WS.length?'Fertig →':wstep===5?'Passt so →':'Weiter →';
}

function renderWizardVisual(s){
  const box=$('lg-wvisual');
  if(!box)return;

  box.innerHTML='';
  box.style.display='none';

  if(s.visual==='fit'){
    box.style.display='grid';
    box.innerHTML=
      `<div class="lg-fit-cards">`+
      FIT_EXAMPLES.map(ex=>{
        const active=(S.fit===ex.key)?' active':'';
        return `
          <button type="button" class="lg-fit-card${active}" data-fit="${esc(ex.key)}">
            <img src="${esc(ex.img)}" alt="${esc(ex.title)}" loading="lazy">
            <strong>${esc(ex.title)}</strong>
            <span>${esc(ex.text)}</span>
          </button>
        `;
      }).join('')+
      `</div>`;
    return;
  }

  if(s.visual==='fill'){
    const b=getBead(S.active);
    box.style.display='grid';
    box.innerHTML=`
      <div class="lg-fill-action">
        <div class="lg-fill-action-inner">
          <div>
            <strong>Basis automatisch füllen</strong>
            <p>Alle freien Positionen werden mit <b>${esc(b?.name||'deiner Wunschperle')}</b> belegt. Danach kannst du einzelne Punkte weiter anpassen.</p>
          </div>
          <button type="button" class="lg-mini-btn" id="lg-fill-active">Jetzt füllen →</button>
        </div>
      </div>
    `;
  }
}

function clwhl(){
  document.querySelectorAll('.wizard-hl,.wizard-fill-target').forEach(el=>el.classList.remove('wizard-hl','wizard-fill-target'));
}

function focusWizardTarget(el,s){
  el.classList.add('wizard-hl');
  if(s.visual==='fill')el.classList.add('wizard-fill-target');
  setTimeout(()=>scrollWizardTarget(el,s),120);
}

function scrollWizardTarget(el,s){
  const reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const behavior=reduce?'auto':'smooth';
  const mobile=window.matchMedia&&window.matchMedia('(max-width: 768px)').matches;

  if(mobile&&s.p==='prev'){
    const rect=el.getBoundingClientRect();
    const desiredTop=s.visual==='fill'?86:70;
    const top=window.scrollY+rect.top-desiredTop;
    window.scrollTo({top:Math.max(0,top),behavior});
    return;
  }

  el.scrollIntoView({behavior,block:mobile?'center':'nearest'});
}

function awiz(){
  if(!wiz)return;

  if(wstep===3&&S.active){wstep=4;uwiz();return}
  if(wstep===4&&S.seq.some(Boolean)){wstep=5;uwiz();return}
  if(wstep===6&&S.center){wstep=7;uwiz()}
}

document.querySelectorAll('.lg-ob-card').forEach(btn=>{
  btn.addEventListener('click',()=>{
    showScr('config');
    setWiz(btn.dataset.mode==='guide');
    sr();
  });
});

elC.addEventListener('click',ev=>{
  const{x,y}=cxy(ev);

  if(ich(x,y)){
    ar(x,y,true);
    ph();
    S.center=S.active;
    awiz();
    sr();
    return;
  }

  const idx=sxy(x,y),cIdx=ci();
  if(idx===null||idx===cIdx)return;

  ar(x,y,false);
  ph();
  ts(idx);
  awiz();
  sr();
});

elC.addEventListener('keydown',ev=>{
  if(ev.key===' '||ev.key==='Enter'){
    ev.preventDefault();
    elC.click();
  }
});

elCat.addEventListener('click',ev=>{
  const ib=ev.target.closest('.lg-ibtn');

  if(ib){
    ev.stopPropagation();
    const tip=ib.closest('.lg-item')?.querySelector('.lg-tip');
    if(!tip)return;
    const was=tip.classList.contains('open');
    ctips();
    tip.classList.toggle('open',!was);
    return;
  }

  const item=ev.target.closest('.lg-item[data-bead]');
  if(!item)return;

  ph();
  S.active=item.dataset.bead;

  if(wiz&&wstep===3){wstep=4;uwiz()}
  else awiz();

  sr();
});

elCat.addEventListener('keydown',ev=>{
  if(ev.key!==' '&&ev.key!=='Enter')return;
  const item=ev.target.closest('.lg-item[data-bead]');
  if(item&&!ev.target.classList.contains('lg-ibtn')){
    ev.preventDefault();
    item.click();
  }
});

let st;

elQ.addEventListener('input',()=>{
  clearTimeout(st);
  st=setTimeout(()=>rc(),160);
});

elSym.addEventListener('change',()=>{
  ph();
  S.sym=elSym.checked;
  elSym.setAttribute('aria-checked',String(S.sym));
  sr();
});

elPre.addEventListener('change',()=>{
  ph();
  S.size=elPre.value;
  const isC=S.size==='custom';
  syncCW(isC);

  if(isC){
    setTimeout(()=>{try{elCust.focus()}catch{}},50);
  }else{
    elCust.value='';
    applySizeSystem();
  }

  if(wiz&&wstep===1){wstep=2;uwiz()}
  sr();
});

elCust.addEventListener('input',()=>{
  ph();
  S.size='custom';
  applySizeSystem();
  sr();
});

if(elFit){
  elFit.addEventListener('change',()=>{
    ph();
    S.fit=elFit.value;
    applySizeSystem();

    if(wiz&&wstep===2){wstep=3;uwiz()}
    sr();
  });
}

elCSZ.addEventListener('change',()=>{
  ph();
  S.csz=Number(elCSZ.value);
  ec();
  scd();
  sr();
});

$('lg-undo').addEventListener('click',()=>{uh();sr()});
$('lg-clear').addEventListener('click',()=>{ph();S.seq=Array(S.total).fill(null);sr()});
$('lg-checkout-btn').addEventListener('click',()=>showScr('checkout'));
$('lg-co-back').addEventListener('click',()=>showScr('config'));
$('lg-mode-btn').addEventListener('click',()=>setWiz(!wiz));

elWN.addEventListener('click',()=>{
  if(wstep<WS.length){wstep++;uwiz()}
  else showScr('checkout');
});

elWBk.addEventListener('click',()=>{
  if(wstep>1){wstep--;uwiz()}
});

document.addEventListener('click',ev=>{
  const fitCard=ev.target.closest('.lg-fit-card[data-fit]');
  if(fitCard){
    if(S.fit===fitCard.dataset.fit){
      syncFitCards();
      return;
    }

    ph();
    S.fit=fitCard.dataset.fit;
    if(elFit)elFit.value=S.fit;
    applySizeSystem();

    if(wiz&&wstep===2){wstep=3;uwiz()}
    sr();
    return;
  }

  const fillBtn=ev.target.closest('#lg-fill-active');
  if(fillBtn)fillWithActiveBead();
});

function ctips(){
  document.querySelectorAll('#lg-wrap .lg-tip.open').forEach(t=>t.classList.remove('open'));
}

document.addEventListener('click',ctips);
document.addEventListener('keydown',ev=>{if(ev.key==='Escape')ctips()});

S.size=elPre?.value||'m';
S.fit=elFit?.value||'normal';
S.total=beadCountFromState();
S.seq=Array(S.total).fill(null);
syncCW(S.size==='custom');
sr();

})();
